import { Styles } from "../../../types/common";

const styles: Styles = {
  detailCard: {
    padding: "15px 10px",
    height: "fit-content",
    width: { md: "33%" },
    position: { md: "sticky" },
    top: "80px",
    "& .head": {
      color: "#54565A",
      fontSize: "14px",
      fontWeight: "700",
    },
    "& .sub_head": {
      color: "#23085A",
      fontSize: "18px",
      marginTop: "15px",
      fontWeight: "700",
    },
    "& .detail_box": {
      background: "white",
      borderRadius: "8px",
      padding: "0 10px",
      margin: "20px 0",
      "& .detail_row": {
        display: "flex",
        justifyContent: "space-between",
        padding: "7px 0",
        alignItems: "center",
        "& .left": {
          fontSize: "13px",
        },
        "& .right": {
          fontSize: "13px",
          display: "flex",
          alignItems: "center",
          gap: "3px",
          "& .dot": {
            borderRadius: "50%",
            height: "10px",
            width: "10px",
          },
        },
        "& .status": {
          padding: "5px 16px",
          gap: "8px",
          borderRadius: "16px",
        },
        "& .Available": {
          background: "#D3F6B8",
          color: "#000000",
          "& .dot": {
            background: "#00953B",
          },
        },
        "& .Limited": {
          background: "rgba(255, 227, 0, 0.25)",
          color: "#472029",
          "& .dot": {
            background: "#472029",
          },
        },
        "& .today": {
          svg: {
            color: "#54565A",
            fontSize: "18px",
          },
        },
        "& .month": {
          svg: {
            color: "#858585",
            fontSize: "18px",
          },
        },
      },
    },
    "& .card_seperator": {
      borderTop: "1px dashed #003B4A",
      margin: "15px 0",
      marginBottom: "0",
    },
    "& .price_field": {
      padding: "14px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      ".left_text": {
        color: "#54565A",
        fontSize: "12px",
        fontWeight: "700",
      },
      ".right_text": {
        color: "#000",
        fontSize: "20px",
        fontWeight: "700",
      },
    },
  },
};

export default styles;
